import { routeGuard } from "../../../router/guard";

export default [
  {
    path: "/serasatest",
    name: "SerasaTest",
    beforeEnter: routeGuard,
    component: () => import("../views/SerasaTest.vue"),
  },
  {
    path: "/serasaapi",
    name: "SerasaApi",
    beforeEnter: routeGuard,
    component: () => import("../views/SerasaAPI.vue"),
  }
]